// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const smoochum: PokeData = {
  "id": 238,
  "name": "smoochum",
  "height": 4,
  "weight": 60,
  "base_experience": 61,
  "types": [
    PokeType.ICE,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "pound",
    "ice-punch",
    "sing",
    "blizzard",
    "confusion",
    "psychic",
    "lick",
    "powder-snow",
    "sweet-kiss",
    "perish-song",
    "mean-look",
    "fake-tears",
    "covet",
    "lucky-chant",
    "copycat",
    "avalanche",
    "heart-stamp"
  ],
  "moves": [
    "ice-punch",
    "blizzard",
    "psychic",
    "lick",
    "sweet-kiss",
    "avalanche",
    "hailstorm",
    "ice-wave",
    "reflect",
    "psychic-terrain",
    "ice-shard",
    "calm-mind",
    "synchronize"
  ],
  "evolution_chain": {
    "id": 59,
    "item": null,
    "species": [
      {
        "name": "smoochum",
        "order": 143,
        "types": [
          PokeType.ICE,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "jynx",
        "order": 144,
        "types": [
          PokeType.ICE,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 238,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 42.5,
    "speed": 65,
    "ability_power": 85
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
